var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("table", { staticClass: "table is-bordered is-fullwidth" }, [
    _c(
      "tbody",
      [
        _vm._l(_vm.flattenedRows, function (row) {
          return [
            _c(
              "tr",
              {
                key: row.permission.permissionRecordID,
                class: {
                  "access-parent-row": row.level === 0,
                  [`theme-${_vm.$theme.name}`]: row.level === 0,
                },
              },
              [
                _c(
                  "td",
                  {
                    style:
                      row.level > 0
                        ? { paddingLeft: `${row.level * 24}px` }
                        : {},
                  },
                  [_vm._v(_vm._s(row.permission.name))]
                ),
                _c("td", { staticClass: "has-text-centered" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "pretty p-icon p-curve p-smooth p-bigger m-0",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: row.permission.active,
                            expression: "row.permission.active",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                          disabled: row.permission.disabled,
                        },
                        domProps: {
                          checked: Array.isArray(row.permission.active)
                            ? _vm._i(row.permission.active, null) > -1
                            : row.permission.active,
                        },
                        on: {
                          change: [
                            function ($event) {
                              var $$a = row.permission.active,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      row.permission,
                                      "active",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      row.permission,
                                      "active",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(row.permission, "active", $$c)
                              }
                            },
                            function ($event) {
                              return _vm.handleToggle(row.permission, row.level)
                            },
                          ],
                        },
                      }),
                      _vm._m(0, true),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("span", { staticClass: "icon mso mso-24px" }, [_vm._v("check")]),
      _c("label"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }